import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getListWithAuthenticated,
  postApiWithAuthenticated,
} from "../ApiMethods/ApiMethod";

const PermissionsBaseURL = `${Base_Url}/Permissions`;

export const GetUserRoleModel = async () => {
  const url = `${PermissionsBaseURL}/GetPermissionModel`;
  const res = await getListWithAuthenticated(url);
  return res;
};

//Set Access Default
export const UpdatePermission = async (payload) => {
  const res = await postApiWithAuthenticated(
    `${PermissionsBaseURL}/AddUpdateDefaultPermissions`,
    payload
  );
  return res;
};
